import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import {SignUpEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {Link} from 'react-router-dom';
import {LoginEnum} from 'main/analytics/gaTagsEnum';
import {StyledTypography} from './styles';

const {newUser} = translations['pt-br'].publicFlow.signIn;
const {notRegistered, registerNewuser} = newUser;

export function NewRegister() {
	return (
		<Stack gap={2} mt={1}>
			<StyledTypography variant="body1">{notRegistered}</StyledTypography>
			<Button
				data-tag-id={LoginEnum.CLICK_FAZER_CADASTRO}
				component={Link}
				size="large"
				to={SignUpEnum.SIGN_UP}
				variant="outlined">
				{registerNewuser}
			</Button>
		</Stack>
	);
}
